import React from 'react';
import PropTypes from 'prop-types';

const injectPropToSpecificComponent = (children, tileData, eventTile) => {
  // If children is an array, map over it
  if (Array.isArray(children)) {
    return children.map((child) => injectPropToSpecificComponent(child, tileData, eventTile));
  }
  // If it's a valid React element
  if (React.isValidElement(children)) {
    // If it's the target component, clone with the new prop
    if (children.type === eventTile) {
      return React.cloneElement(children, {tileData});
    }
    // If the child has its own children, recurse
    const childProps = children.props;
    if (childProps.children !== undefined) {
      const newChildren = injectPropToSpecificComponent(childProps.children, tileData, eventTile);
      return React.cloneElement(children, {}, newChildren);
    }
    return children;
  }
  // If it's something else (e.g. fragment), just return as is
  return children;
};

const EventWrapper = (props) => {
  const {children, ...tileData} = props;
  const eventTile = props.components.event;
  const enhancedChildren = injectPropToSpecificComponent(children, tileData, eventTile);
  return <>{enhancedChildren}</>;
};

EventWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  tileData: PropTypes.bool,
  components: PropTypes.any,
};

export default EventWrapper;
